// How a workspace's email sending state is shown: the status pill's tone and
// its label. Shared by the operator's control in the tenant drawer
// (SendingStateControl) and the Sending column of the Tenants and usage table
// (AdminUsagePlans), so both always say the same thing.
//
// A state is off, test, live or paused; a pause carries a reason: owner (the
// workspace owner paused it), operator, or auto: and a rule when the platform
// paused it by itself.

const TONES = { live: 'success', test: 'warning', paused: 'neutral', off: 'danger' };
const LABELS = { off: 'Off', test: 'Test', live: 'Live' };

/** The MusubiStatusPill tone for a sending state. */
export function sendingStateTone(state) {
  return TONES[state] || 'neutral';
}

/** The pill label for { state, reason }. */
export function sendingStateLabel(d) {
  const state = d && d.state;
  const reason = d && d.reason;
  if (state === 'paused' && typeof reason === 'string' && reason.startsWith('auto:')) return 'Paused automatically';
  if (state === 'paused') return reason === 'owner' ? 'Paused by the owner' : 'Paused by Yorlin';
  return LABELS[state] || state || '';
}
